<template>
  <v-dialog
    v-model="visible"
    v-if="visible"
    @keydown.esc="close"
    persistent
    :max-width="tab == 'ClosingBalanceList' ? '900px' : '900px'"
    content-class="my-custom-dialog"
  >
    <v-form
      ref="createReportForm"
      style="border-radius: 25px !important"
      @submit.prevent="submit"
    >
      <v-card
        class="overflow-auto"
        :class="{ 'mobile-dialog-card': $vuetify.breakpoint.smAndDown }"
        style="border-radius: 25px"
      >
        <v-card-title
          class="d-flex"
          style="
            vertical-align: middle;
            background-color: #1577da;

            height: 58px;
            color: white;
          "
        >
          <span class="text-h5" style="font-weight: bold"
            >Zaključak blagajne</span
          >
        </v-card-title>

        <!-- <v-card-title class="d-flex" style="vertical-align: middle">
          <v-row class="pa-3 mb-2">
            <h2 class="text--secondary">Zaključak blagajne</h2>
            <v-spacer></v-spacer>
            <v-icon large @click="close">mdi-close</v-icon>
          </v-row>
        </v-card-title> -->
        <v-card-text class="pl-0 ml-0 pt-5">
          <v-row>
            <v-col :cols="tab == 'ClosingBalanceList' ? 3 : 3">
              <v-tabs vertical v-model="tab">
                <v-tab class="justify-start" href="#ClosingBalance"
                  >Zaključak blagajne</v-tab
                >
                <!-- ZAKOMENTIRANO ZA KAD SE NAPRAVI PRINT -->
                <!-- <v-tab class="justify-start"
                  href="#ClosingBalanceTimeRange">Zaključak vremenski</v-tab> -->
                <v-tab class="justify-start" href="#ClosingBalanceList"
                  >Lista zaključaka</v-tab
                >
              </v-tabs>
            </v-col>
            <v-divider vertical inset></v-divider>
            <v-col
              style="min-width: 100px; max-width: 100%"
              :class="[densityPadding, 'flex-grow-1']"
            >
              <div>
                <v-tabs-items v-model="tab">
                  <v-tab-item value="ClosingBalance">
                    <closing-balance
                      ref="closingBalance"
                      @receiptPrint="setReceiptPrint"
                    ></closing-balance>
                  </v-tab-item>
                  <v-tab-item value="ClosingBalanceTimeRange">
                    <closing-balance-time-range
                      :tab="tab"
                      @loading="onLoading"
                      ref="closingBalance"
                      @receiptPrint="setReceiptPrint"
                    ></closing-balance-time-range>
                  </v-tab-item>
                  <v-tab-item value="ClosingBalanceList">
                    <closing-balance-list
                      @setPrintState="setPrintState"
                    ></closing-balance-list>
                  </v-tab-item>
                </v-tabs-items>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-center pb-5 pr-5">
          <v-spacer></v-spacer>
          <v-btn
            v-if="tab == 'ClosingBalance'"
            class="btn infoButton"
            @click="openBalancePreview"
            >Ispis totala</v-btn
          >
          <v-btn id="danger" class="btn dangerButton" @click="close">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn
            v-if="tab == 'ClosingBalance'"
            id="success"
            class="btn successButton"
            @click="openWithdrawDialog"
          >
            Zaključi blagajnu
          </v-btn>
        </v-card-actions>
        <v-dialog v-model="showWithdrawDialog" width="25%">
          <v-card>
            <v-card-title class="d-flex" style="vertical-align: middle">
              <v-row class="pa-3 mb-2">
                <h3 class="text--secondary">Zaključak</h3>
                <v-spacer></v-spacer>
                <v-icon large @click="showWithdrawDialog = !showWithdrawDialog"
                  >mdi-close</v-icon
                >
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row class="pb-3"> </v-row>
              <v-row class="pb-3">
                <div
                  style="
                    padding-left: 10px;
                    padding-top: 7px;
                    padding-right: 5px;
                  "
                >
                  Iznos novca za polaganje u banku:
                </div>
                <div style="padding-top: -5px; max-width: 24% !important">
                  <quantity-input
                    dense
                    hide-details
                    v-model="withdrawAmount"
                    suffix="€"
                  ></quantity-input>
                </div>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn id="success" class="btn successButton" @click="submit()">
                Zaključi blagajnu
              </v-btn>

              <v-btn
                id="danger"
                class="btn dangerButton"
                @click="showWithdrawDialog = false"
              >
                Zatvori
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Print Articles Confirmation Dialog -->
        <v-dialog v-model="showPrintArticlesDialog" max-width="500px" persistent>
          <v-card>
            <v-card-title class="d-flex" style="vertical-align: middle">
              <v-row class="pa-3 mb-2">
                <h3 class="text--secondary">Ispis totala</h3>
                <v-spacer></v-spacer>
                <v-icon large @click="cancelPrint">mdi-close</v-icon>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row class="pb-3">
                <v-col cols="12">
                  <p style="font-size: 16px;">
                    Želite li printati artikle?
                  </p>
                  <p style="font-size: 14px; color: #666;">
                    (Pronađeno: <strong>{{ articlesCount }}</strong> {{ articlesCount === 1 ? 'artikl' : articlesCount > 1 && articlesCount < 5 ? 'artikla' : 'artikala' }})
                  </p>
                  <p style="font-size: 13px; color: #999;">
                    Ispis bi mogao biti velik.
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="d-flex justify-center pb-5">
              <v-btn class="btn dangerButton" @click="cancelPrint">
                Odustani
              </v-btn>
              <v-btn class="btn warningButton" @click="printWithoutArticles">
                Ne, bez artikala
              </v-btn>
              <v-btn class="btn successButton" @click="printWithArticles">
                Da, sa artiklima
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Close Balance Articles Confirmation Dialog -->
        <v-dialog v-model="showCloseBalanceArticlesDialog" max-width="500px" persistent>
          <v-card>
            <v-card-title class="d-flex" style="vertical-align: middle">
              <v-row class="pa-3 mb-2">
                <h3 class="text--secondary">Zaključak blagajne</h3>
                <v-spacer></v-spacer>
                <v-icon large @click="cancelCloseBalancePrint">mdi-close</v-icon>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row class="pb-3">
                <v-col cols="12">
                  <p style="font-size: 16px;">
                    Želite li printati artikle?
                  </p>
                  <p style="font-size: 13px; color: #999;">
                    Ispis bi mogao biti velik.
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="d-flex justify-center pb-5">
              <v-btn class="btn dangerButton" @click="cancelCloseBalancePrint">
                Odustani
              </v-btn>
              <v-btn class="btn warningButton" @click="printCloseBalanceWithoutArticles">
                Ne, bez artikala
              </v-btn>
              <v-btn class="btn successButton" @click="printCloseBalanceWithArticles">
                Da, sa artiklima
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-overlay v-if="loading" absolute z-index="10">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
          ></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import ClosingBalance from '@/modules/cash-register/components/closeBalance/components/ClosingBalance'
import ClosingBalanceTimeRange from '@/modules/cash-register/components/closeBalance/components/ClosingBalanceTimeRange'
import ClosingBalanceList from '@/modules/cash-register/components/closeBalance/components/ClosingBalanceList'
import state from '@/state'
import applicationSettings from '@/mixins/applicationSettings' // don't move.. detaches firebase listeners
import { v4 as uuidv4 } from 'uuid'
import { df, auth, functions } from '@/plugins/firebase'
import { clone } from '@/plugins/utils'
import EventBus from '@/plugins/event-bus'
import { closingBalance } from '@/libs/closingBalance/closingBalance.js'
import { printBalancePreview } from '@/libs/bixolon/printBalancePreview'
import LogData from '@/model/LogData'
import log from '@/mixins/log'
import QuantityInput from '@/components/QuantityInput.vue'

export default {
  components: { ClosingBalance, ClosingBalanceList, QuantityInput, ClosingBalanceTimeRange },
  inject: ['showMsgBox', 'openPdfPrint', 'confirm', 'confirmClose'],
  mixins: [applicationSettings, log],
  data: function () {
    return {
      visible: false,
      tab: 'ClosingBalance',
      loading: false,
      lastBalanceId: '',
      receiptPrint: true,
      selectedPrinter: {},
      showWithdrawDialog: false,
      withdrawAmount: 0,
      dateFromTimestamp: null,
      dateToTimestamp: null,
      showPrintArticlesDialog: false,
      balanceReportData: null,
      articlesCount: 0,
      closeBalanceData: null,
      showCloseBalanceArticlesDialog: false
    }
  },
  mounted () {
    EventBus.$on('set-selected-printer', (printer) => {
      this.selectedPrinter = printer
    })
  },
  computed: {
    formattedDateFrom () {
      return this.formatDateForDisplay(this.dateFrom)
    },
    formattedDateTo () {
      return this.formatDateForDisplay(this.dateTo)
    },
    minDateFrom () {
      if (this.lastBalanceTimestamp) {
        // Konvertiraj timestamp (sekunde) u Date objekt
        const lastBalanceDate = new Date(this.lastBalanceTimestamp * 1000)
        // Vrati u YYYY-MM-DD formatu
        return lastBalanceDate.toISOString().substr(0, 10)
      }
      // Ako nema zadnjeg zaključka, nema ni minimalnog datuma (ili postavite na neki fiksni stari datum ako je potrebno)
      return null
    }
  },
  methods: {
    onLoading (state) {
      switch (state) {
        case true:
          this.loading = true
          break
        case false:
          this.loading = false
          break
      }
    },
    formatDateForDisplay (dateString) { // Pomoćna funkcija za formatiranje
      if (!dateString) return null
      try {
        const [year, month, day] = dateString.split('-')
        return `${day}.${month}.${year}`
      } catch (e) {
        console.error('Error formatting date for display:', dateString, e)
        return dateString // Vrati originalni string ako dođe do greške
      }
    },
    prepareLogCall () {
      var req = new LogData()

      let userId = auth.currentUser.uid
      if (state.getCashRegisterUser().id && state.getCashRegisterUser().id !== '') {
        userId = state.getCashRegisterUser().id
      }

      req.action_name = 'Ispis totala'
      req.action_id = '8'
      req.user_id = userId

      this.setLog(req)
    },
    async openBalancePreview () {
      var amounts = this.$refs.closingBalance.getBalanceAmounts()

      var fromDate
      var toDate
      if (amounts.dateFromTimestamp) {
        fromDate = amounts.dateFromTimestamp
      }

      if (amounts.dateToTimestamp) {
        toDate = amounts.dateToTimestamp
      }

      if (state.getCurrentCompany().save_log) {
        this.prepareLogCall()
      }
      this.loading = true
      var balancePreview = functions.httpsCallable('balancepreview')

      var params = {
        company_id: state.getCurrentCompany().id,
        location_id: state.getPointOfSale().id,
        register_id: state.getCashRegister().id
      }

      if (fromDate) {
        params.from = fromDate
      }

      if (toDate) {
        params.to = toDate
      }

      balancePreview(params)
        .then(async (result) => {
          this.loading = false

          if (result && result.data.code === 200 && result.data.balance_report) {
            // Cache podatke i otvori dijalog za izbor
            this.balanceReportData = result.data.balance_report
            // Prebrojaj artikle
            this.articlesCount = result.data.balance_report.artikli ? result.data.balance_report.artikli.length : 0
            this.showPrintArticlesDialog = true
          }
        })
        .catch((error) => {
          this.loading = false
          console.error('Error loading balance preview:', error)
        })
    },
    printWithArticles () {
      this.showPrintArticlesDialog = false
      if (this.balanceReportData) {
        printBalancePreview(this.balanceReportData, this.selectedPrinter, true)
        this.balanceReportData = null
      }
    },
    printWithoutArticles () {
      this.showPrintArticlesDialog = false
      if (this.balanceReportData) {
        printBalancePreview(this.balanceReportData, this.selectedPrinter, false)
        this.balanceReportData = null
      }
    },
    cancelPrint () {
      this.showPrintArticlesDialog = false
      this.balanceReportData = null
    },
    printCloseBalanceWithArticles () {
      this.showCloseBalanceArticlesDialog = false
      if (this.closeBalanceData) {
        closingBalance(this.closeBalanceData, this.selectedPrinter, true)
        this.closeBalanceData = null
      }
    },
    printCloseBalanceWithoutArticles () {
      this.showCloseBalanceArticlesDialog = false
      if (this.closeBalanceData) {
        closingBalance(this.closeBalanceData, this.selectedPrinter, false)
        this.closeBalanceData = null
      }
    },
    cancelCloseBalancePrint () {
      this.showCloseBalanceArticlesDialog = false
      this.closeBalanceData = null
    },
    async open () {
      this.visible = true
      await this.setLastBalanceId()
      this.setPrintListener()
    },
    close () {
      this.visible = false
      this.$refs.closingBalance.resetReceiptPrint()
      this.detachListeners()
    },
    setPrintState (state) {
      this.loading = state
    },
    setReceiptPrint (state) {
      this.receiptPrint = state
    },
    setPrintListener () {
      const docRef = df.doc(`user_cash_registers/${auth.currentUser.uid}.${state.getCurrentCompany().id}.${state.getPointOfSale().id}`)
      this.listeners.push(docRef.onSnapshot((doc) => {
        const data = doc.data()
        if (data?.cash_registers) {
          const register = data.cash_registers[state.getCashRegister().id]
          if (!register) return
          if (register.last_balance_id && register.last_balance_id !== this.lastBalanceId) {
            if (['T58', 'T80', 'A4'].includes(this.selectedPrinter.width)) {
              this.printDocument(register.last_balance_id)
            } else {
              this.printLocal(register.last_balance_id)
            }
            this.lastBalanceId = clone(register.last_balance_id)
          }
        }
      })
      )
    },
    // defaultno dohvatiti datume
    openWithdrawDialog () {
      var amounts = this.$refs.closingBalance.getBalanceAmounts()
      this.withdrawAmount = amounts.withdrawAmount

      const cashRegisterData = state.getCashRegister()
      this.lastBalanceTimestamp = cashRegisterData?.last_balance_timestamp || null

      if (this.lastBalanceTimestamp) {
        const lastBalanceDate = new Date(this.lastBalanceTimestamp * 1000)
        this.dateFrom = lastBalanceDate.toISOString().substr(0, 10)
      } else {
        console.warn("Nije pronađen timestamp zadnjeg zaključka, 'Datum od' postavljen na danas.")
        this.dateFrom = new Date().toISOString().substr(0, 10)
      }
      this.dateTo = new Date().toISOString().substr(0, 10)

      this.showWithdrawDialog = true
    },
    submit () {
      this.showWithdrawDialog = false
      this.loading = true

      var amounts = this.$refs.closingBalance.getBalanceAmounts()
      var withdrawAmount = this.formatNumber(this.withdrawAmount, 100)
      var availableFunds = this.formatNumber(amounts.availableFunds, 1)
      var previousAmount = this.formatNumber(amounts.previousAmount, 1)
      var tipCash = amounts.tipCash || 0
      var maxWithdraw = (availableFunds + previousAmount + tipCash)

      if (withdrawAmount > maxWithdraw) {
        this.showMsgBox({
          text: `Iznos za polaganje u banku ne može biti veći od ${maxWithdraw / 100} €. Molimo ispravite iznos kako bi kreirali zaključak blagajne.`,
          actions: ['cancel'],
          cancelBtnText: this.$t('$vuetify.close'),
          color: 'error'
        })
        this.loading = false
        return
      }

      const payload = {
        action: {
          operation: 'set',
          entity: 'balance',
          params: {
            company_id: state.getCurrentCompany().id,
            location_id: state.getPointOfSale().id,
            register_id: state.getCashRegister().id,
            withdraw_amount: withdrawAmount
          }
        }
      }

      let userId = auth.currentUser.uid
      if (state.getCashRegisterUser().id && state.getCashRegisterUser().id !== '') {
        userId = state.getCashRegisterUser().id
      }

      payload.action.params.user_id = userId

      try {
        // const reqId = uuidv4()
        this.$emit('setPrintState', true)

        var cashregisterApi = functions.httpsCallable('cashregisterapi')

        cashregisterApi({
          action: {
            operation: 'set',
            entity: 'balance',
            params: payload.action.params
          }
        })
          .then((result) => {
            if (result.data.code === 200) {
              this.getCashRegister()
            }
          })

        // df.doc(`request/${reqId}`)
        //   .set({
        //     user_id: `${userId}`,
        //     device_id: 'web',
        //     created: `${new Date().getTime()}`,
        //     type: 'cashregister',
        //     payload: btoa(
        //       unescape(encodeURIComponent(JSON.stringify(payload)))
        //     )
        //   })
        //   .catch((err) => {
        //     this.showMsgBox({
        //       text: err && err !== '' ? err : 'An error has occurred',
        //       actions: ['cancel'],
        //       cancelBtnText: this.$t('$vuetify.close'),
        //       color: 'error'
        //     })
        //   })
      } catch (err) {
        this.showMsgBox({
          text: err && err !== '' ? err : 'An error has occurred',
          actions: ['cancel'],
          cancelBtnText: this.$t('$vuetify.close'),
          color: 'error'
        })
      }

      setTimeout(() => { this.getCashRegister() }, 5000)
    },
    async getCashRegister () {
      if (!state.getCashRegister()?.id) { return }
      const response = await df.doc(`cash_registers/${state.getCashRegister().id}`).get()
      if (!response.data()) {
        throw new Error('Nije moguće dohvatiti podatke o blagajni')
      } else {
        state.setCashRegister(response.data())
        EventBus.$emit('refreshCashRegister')
      }
    },
    formatNumber (num, multiplier = 100) {
      if (!num || num === '' || num === 0) return 0

      var bla = num.toString().trim()
      if (bla === '') return 0

      var number = bla.replace(/,/g, '.')

      number = parseFloat(number)
      return parseInt(number * multiplier)
    },
    async printLocal (balanceId) {
      this.confirm({
        title: 'Zaključak blagajne',
        message: 'Da li želite isprintati zaključak blagajne?',
        options: {
          toolbar: true,
          width: 410,
          confirmText: 'DA',
          cancelText: 'NE'
        }
      }).then(async (resp) => {
        if (resp) {
          this.confirmClose()
          const response = await df.doc(`cash_registers/${state.getCashRegister().id}/balances/${balanceId}`).get()
          if (response && response.data()) {
            // Cache podatke i otvori dijalog za izbor artikala
            this.closeBalanceData = response.data()
            this.showCloseBalanceArticlesDialog = true
            this.loading = false
          }
        } else {
          this.confirmClose()
          this.loading = false
        }
      })
    },

    printDocument (balanceId) {
      const payload = {
        action: {
          entity: 'cashier_balance',
          operation: 'get',
          resource_id: balanceId,
          params: {
            company_id: state.getCurrentCompany().id,
            print_size: state.getPrinter(),
            print_receipts: this.receiptPrint,
            cash_register_id: state.getCashRegister().id
          }
        }
      }

      const reqId = uuidv4()
      df.doc(`request/${reqId}`)
        .set({
          user_id: `${auth.currentUser.uid}`,
          device_id: 'web',
          created: `${new Date().getTime()}`,
          type: 'document',
          payload: btoa(unescape(encodeURIComponent(JSON.stringify(payload))))
        })
        .catch((err) => {
          this.showMsgBox({
            text: err && err !== '' ? err : 'An error has occurred',
            actions: ['cancel'],
            cancelBtnText: this.$t('$vuetify.close'),
            color: 'error'
          })
        })
      const docRef = df.doc(`response/${reqId}`)
      const unsubscribe = docRef.onSnapshot((doc) => {
        const data = doc.data()
        if (data) {
          unsubscribe()
          this.loading = false

          if (!data.body || !data.body.document) {
            this.showMsgBox({
              text: this.$t('$vuetify.errors.nullClosingBalance'),
              actions: ['cancel'],
              cancelBtnText: this.$t('$vuetify.close'),
              color: 'error'
            })
            return
          }
          this.openPdfPrint(data.body.document)
        }
      })
    },
    async setLastBalanceId () {
      const registersDoc = await df
        .doc(
          `user_cash_registers/${auth.currentUser.uid}.${state.getCurrentCompany().id
          }.${state.getPointOfSale().id}`
        )
        .get()
      const registerBalanceId =
        registersDoc.data()?.cash_registers?.[state.getCashRegister().id]
          ?.last_balance_id
      this.lastBalanceId = registerBalanceId ? clone(registerBalanceId) : ''
    }
  }
}
</script>
<style scoped>
.v-dialog__content >>> .my-custom-dialog {
  border-radius: 25px !important;
  z-index: 6;
}
</style>
